<template>
  <div>
    <v-row class="d-flex justify-end mt-n9">
      <v-col md="2" cols="12" class="d-flex flex-column mt-1">
        <v-card color="white" elevation="0" class="d-flex flex-column text-center" v-if="mostrarContadorMensal">
          <div v-if="!this.$isMobile()">
            <p class="text-caption">
              {{ contadorMensal }}/30
              <v-icon size="small" :color="contadorMensalCor">mdi-chart-areaspline-variant</v-icon>
            </p>
          </div>
          <v-tooltip location="bottom" max-width="400px">
            <template v-slot:activator="{ props }">
              <p class="text-caption" v-bind="props">{{ this.nomePlano }}</p>
              <v-btn
                v-if="!this.$isMobile()"
                elevation="0"
                color="red"
                @click="setDialog(true)"
                size="small"
              >
                Alterar Plano
              </v-btn>
              <v-btn
                v-else
                height="28"
                width="28"
                elevation="0"
                color="red"
                @click="setDialog(true)"
                icon
                class="ma-auto"
              >
                <v-icon size="small">mdi-pencil</v-icon>
              </v-btn>
            </template>
            <div style="max-height: 300px;overflow-y: auto;">
              <div class="text-caption" style="white-space: pre-wrap;">{{ this.planoDetails }}</div>
            </div>
          </v-tooltip>
          <v-progress-linear
            class="text-white mt-4"
            style="width: 75%"
            height="5"
            rounded="1"
            :model-value="contadorMensal*2"
            :color="contadorMensalCor"
          ></v-progress-linear>
        </v-card>
        <v-card color="white" elevation="0" class="d-flex flex-column text-center" v-else>
          <v-tooltip location="bottom" max-width="400px">
            <template v-slot:activator="{ props }">
              <p class="text-caption" v-bind="props">{{ this.nomePlano }}</p>
              <v-btn
                v-if="!this.$isMobile()"
                elevation="0"
                color="red"
                @click="setDialog(true)"
                size="small"
              >
                Alterar Plano
              </v-btn>
              <v-btn
                v-else
                height="28"
                width="28"
                elevation="0"
                color="red"
                @click="setDialog(true)"
                icon
                class="ma-auto"
              >
                <v-icon size="small">mdi-pencil</v-icon>
              </v-btn>
            </template>
            <div style="max-height: 300px;overflow-y: auto;">
              <div class="text-caption" style="white-space: pre-wrap;">{{ this.planoDetails }}</div>
            </div>
          </v-tooltip>
          </v-card>
      </v-col>
    </v-row>
    <v-dialog v-model="dialogAberto" max-width="800px">
      <dialogPlano
        @fechar-dialog="setDialog(false)"
        @abrir-dialogo-cartao="abrirDialogoCartao()"
        @plano-selecionado="handlePlanoSelecionado"
      />
    </v-dialog>
    <v-dialog v-model="dialogCartaoVisivel" max-width="800px">
      <dialogCard
        @fechar-dialog="dialogCartaoVisivel = false"
        @cartao-selecionado="handleCartaoSelecionado"
      />
    </v-dialog>
    <v-dialog v-model="dialogLimiteAtingido" max-width="800px" persistent>
      <v-card rounded="lg">
        <v-card-title class="headline error white--text d-flex align-center" style="background-color: #EF5350;">
          <v-icon left>mdi-alert-decagram</v-icon>
          Limite do Plano Gratuito Atingido
        </v-card-title>
        <v-card-text class="pt-6 text-body-1">
          <p>
            O número máximo de 30 pedidos/encomendas para o seu Plano Gratuito foi alcançado.
          </p>
          <p class="mt-4 font-weight-bold">
            Se você continuar a receber pedidos:
          </p>
          <v-alert
            type="warning"
            variant="tonal"
            class="mt-2"
          >
            Os pedidos excedentes terão um custo de R$ 0,99 por unidade.
          </v-alert>
          <p class="mt-4">
            Para evitar custos adicionais e ter recursos ilimitados, recomendamos Alterar Plano.
          </p>
        </v-card-text>
        <v-card-actions class="d-flex pr-4 pb-4">
          <v-tooltip
              text="Ao cancelar, o registro de novos pedidos/encomendas será bloqueado até a virada do mês."
              location="bottom"
          >
            <template v-slot:activator="{ props }">
              <v-btn
                color="grey-darken-1"
                variant="text"
                @click="cancelamento(); fecharDialogLimite()"
                v-bind="props" 
              >
                Cancelar
              </v-btn>
            </template>
          </v-tooltip>
          <v-spacer></v-spacer>
          <v-btn
            color="red-darken-1"
            variant="flat"
            @click="setDialog(true); fecharDialogLimite();"
          >
            Alterar Plano
          </v-btn>
          <v-btn
            color="blue-darken-1"
            variant="flat"
            @click="fecharDialogLimite()"
          >
            Entendi e Continuar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-row
      class="pt-1 pb-1 d-flex justify-start"
      v-if="this.$route.path.match('/encomendas')"
    >
      <v-col cols="6" md="3" class="d-flex flex-column mt-1" style="cursor: pointer" @click="changeRoute(`/encomendas/recebimentos`)">
        <div class="d-flex flex-row">
          <div
            style="
              min-height: 10px;
              max-height: 3vh;
              width: 34%;
              background-color: #9c27b0;
            "
          ></div>
          <div
            style="
              min-height: 10px;
              max-height: 3vh;
              width: 34%;
              background-color: #ce93d8;
            "
            class="text-center"
          >
            <v-icon size="small" color="white">mdi-alert-outline</v-icon>
          </div>
          <div
            style="
              min-height: 10px;
              max-height: 3vh;
              width: 34%;
              background-color: #9c27b0;
            "
          ></div>
        </div>
        <v-card
          color="#9C27B0"
          style="
            min-height: 50px;
            min-width: 100%;
            border-top: 0px;
            border-top-left-radius: 0px;
            border-top-right-radius: 0px;
          "
          class="d-flex flex-column text-white text-overline"
        >
          <div class="ma-auto">
            <h5>Recebimentos</h5>
          </div>
          <div class="ma-auto mt-n2">
            <h5>
              {{ this.recebidos.length }}
            </h5>
          </div>
        </v-card>
      </v-col>
      <v-col cols="6" md="3" class="d-flex flex-column mt-1" style="cursor: pointer" @click="changeRoute(`/encomendas/aceitos`)">
        <div class="d-flex flex-row">
          <div
            style="
              min-height: 10px;
              max-height: 3vh;
              width: 34%;
              background-color: #3f51b5;
            "
          ></div>
          <div
            style="
              min-height: 10px;
              max-height: 3vh;
              width: 34%;
              background-color: #9fa8da;
            "
            class="text-center"
          >
            <v-icon size="small" color="white">mdi-check</v-icon>
          </div>
          <div
            style="
              min-height: 10px;
              max-height: 3vh;
              width: 34%;
              background-color: #3f51b5;
            "
          ></div>
        </div>
        <v-card
          color="#3F51B5"
          style="
            min-height: 50px;
            min-width: 100%;
            border-top: 0px;
            border-top-left-radius: 0px;
            border-top-right-radius: 0px;
          "
          class="d-flex flex-column text-white text-overline"
        >
          <div class="ma-auto">
            <h5>Aceitos</h5>
          </div>
          <div class="ma-auto mt-n2">
            <h5>
              {{ this.aceitos.length }}
            </h5>
          </div>
        </v-card>
      </v-col>
      <v-col cols="6" md="3" class="d-flex flex-column mt-1" style="cursor: pointer" @click="changeRoute(`/encomendas/emproducao`)">
        <div class="d-flex flex-row">
          <div
            style="
              min-height: 10px;
              max-height: 3vh;
              width: 34%;
              background-color: #ffc107;
            "
          ></div>
          <div
            style="
              min-height: 10px;
              max-height: 3vh;
              width: 34%;
              background-color: #ffe082;
            "
            class="text-center"
          >
            <v-icon size="small" color="white">mdi-gas-burner</v-icon>
          </div>
          <div
            style="
              min-height: 10px;
              max-height: 3vh;
              width: 34%;
              background-color: #ffc107;
            "
          ></div>
        </div>
        <v-card
          color="#FFC107"
          style="
            min-height: 50px;
            min-width: 100%;
            border-top: 0px;
            border-top-left-radius: 0px;
            border-top-right-radius: 0px;
          "
          class="d-flex flex-column text-white text-overline"
        >
          <div class="ma-auto">
            <h5>Em Producao</h5>
          </div>
          <div class="ma-auto mt-n2">
            <h5>
              {{ this.emProducao.length }}
            </h5>
          </div>
        </v-card>
      </v-col>
      <v-col cols="6" md="3" class="d-flex flex-column mt-1" style="cursor: pointer" @click="changeRoute(`/encomendas/prontos`)">
        <div class="d-flex flex-row">
          <div
            style="
              min-height: 10px;
              max-height: 3vh;
              width: 34%;
              background-color: #4caf50;
            "
          ></div>
          <div
            style="
              min-height: 10px;
              max-height: 3vh;
              width: 34%;
              background-color: #a5d6a7;
            "
            class="text-center"
          >
            <v-icon size="small" color="white">mdi-thumb-up-outline</v-icon>
          </div>
          <div
            style="
              min-height: 10px;
              max-height: 3vh;
              width: 34%;
              background-color: #4caf50;
            "
          ></div>
        </div>
        <v-card
          color="#4CAF50"
          style="
            min-height: 50px;
            min-width: 100%;
            border-top: 0px;
            border-top-left-radius: 0px;
            border-top-right-radius: 0px;
          "
          class="d-flex flex-column text-white text-overline"
        >
          <div class="ma-auto">
            <h5>Prontos</h5>
          </div>
          <div class="ma-auto mt-n2">
            <h5>
              {{ this.prontos.length }}
            </h5>
          </div>
        </v-card>
      </v-col>
    </v-row>
    <v-row
      class="pt-1 pb-1 d-flex justify-start"
      v-if="this.$route.path.match('/pedidos')"
    >
      <v-col cols="6" md="3" class="d-flex flex-column mt-1" style="cursor: pointer" @click="changeRoute(`/pedidos/recebimentos`)">
        <div class="d-flex flex-row">
          <div
            style="
              min-height: 10px;
              max-height: 3vh;
              width: 34%;
              background-color: #9c27b0;
            "
          ></div>
          <div
            style="
              min-height: 10px;
              max-height: 3vh;
              width: 34%;
              background-color: #ce93d8;
            "
            class="text-center"
          >
            <v-icon size="small" color="white">mdi-alert-outline</v-icon>
          </div>
          <div
            style="
              min-height: 10px;
              max-height: 3vh;
              width: 34%;
              background-color: #9c27b0;
            "
          ></div>
        </div>
        <v-card
          color="#9C27B0"
          style="
            min-height: 50px;
            min-width: 100%;
            border-top: 0px;
            border-top-left-radius: 0px;
            border-top-right-radius: 0px;
          "
          class="d-flex flex-column text-white text-overline"
        >
          <div class="ma-auto">
            <h5>Recebimentos</h5>
          </div>
          <div class="ma-auto mt-n2">
            <h5>
              {{ this.recebidos.length }}
            </h5>
          </div>
        </v-card>
      </v-col>
      <v-col cols="6" md="3" class="d-flex flex-column mt-1" style="cursor: pointer" @click="changeRoute(`/pedidos/emproducao`)">
        <div class="d-flex flex-row">
          <div
            style="
              min-height: 10px;
              max-height: 3vh;
              width: 34%;
              background-color: #3f51b5;
            "
          ></div>
          <div
            style="
              min-height: 10px;
              max-height: 3vh;
              width: 34%;
              background-color: #9fa8da;
            "
            class="text-center"
          >
            <v-icon size="small" color="white">mdi-gas-burner</v-icon>
          </div>
          <div
            style="
              min-height: 10px;
              max-height: 3vh;
              width: 34%;
              background-color: #3f51b5;
            "
          ></div>
        </div>
        <v-card
          color="#3F51B5"
          style="
            min-height: 50px;
            min-width: 100%;
            border-top: 0px;
            border-top-left-radius: 0px;
            border-top-right-radius: 0px;
          "
          class="d-flex flex-column text-white text-overline"
        >
          <div class="ma-auto">
            <h5>Em Producao</h5>
          </div>
          <div class="ma-auto mt-n2">
            <h5>
              {{ this.emProducao.length }}
            </h5>
          </div>
        </v-card>
      </v-col>
      <v-col cols="6" md="3" class="d-flex flex-column mt-1" style="cursor: pointer" @click="changeRoute(`/pedidos/pronto`)">
        <div class="d-flex flex-row">
          <div
            style="
              min-height: 10px;
              max-height: 3vh;
              width: 34%;
              background-color: #ffc107;
            "
          ></div>
          <div
            style="
              min-height: 10px;
              max-height: 3vh;
              width: 34%;
              background-color: #ffe082;
            "
            class="text-center"
          >
            <v-icon size="small" color="white">mdi-thumb-up-outline</v-icon>
          </div>
          <div
            style="
              min-height: 10px;
              max-height: 3vh;
              width: 34%;
              background-color: #ffc107;
            "
          ></div>
        </div>

        <v-card
          color="#FFC107"
          style="
            min-height: 50px;
            min-width: 100%;
            border-top: 0px;
            border-top-left-radius: 0px;
            border-top-right-radius: 0px;
          "
          class="d-flex flex-column text-white text-overline"
        >
          <div class="ma-auto">
            <h5>Prontos</h5>
          </div>
          <div class="ma-auto mt-n2">
            <h5>
              {{ this.prontos.length }}
            </h5>
          </div>
        </v-card>
      </v-col>
      <v-col cols="6" md="3" class="d-flex flex-column mt-1" style="cursor: pointer" @click="changeRoute(`/pedidos/tele`)">
        <div class="d-flex flex-row">
          <div
            style="
              min-height: 10px;
              max-height: 3vh;
              width: 34%;
              background-color: #4caf50;
            "
          ></div>
          <div
            style="
              min-height: 10px;
              max-height: 3vh;
              width: 34%;
              background-color: #a5d6a7;
            "
            class="text-center"
          >
            <v-icon size="small" color="white">mdi-moped-outline</v-icon>
          </div>
          <div
            style="
              min-height: 10px;
              max-height: 3vh;
              width: 34%;
              background-color: #4caf50;
            "
          ></div>
        </div>
        <v-card
          color="#4CAF50"
          style="
            min-height: 50px;
            min-width: 100%;
            border-top: 0px;
            border-top-left-radius: 0px;
            border-top-right-radius: 0px;
          "
          class="d-flex flex-column text-white text-overline"
        >
          <div class="ma-auto">
            <h5>Em Tele</h5>
          </div>
          <div class="ma-auto mt-n2">
            <h5>
              {{ this.tele.length }}
            </h5>
          </div>
        </v-card>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { getPlanos } from "../libs/getPlano";
import dialogPlano from "../components/dialogPlano.vue";
import dialogCard from "../components/dialogCard.vue";
import { desativaPedidos } from "../libs/Pedidos/desativaPedidos";
import { updatePlanCadastro } from "../libs/updatePlanCadastro";
import { updatePedidosExcedentes } from "../libs/Pedidos/updatePedidosExcedentes"

export default {
  name: "StatusCount",
  components: {
    dialogPlano,
    dialogCard,
  },
  data: () => ({
    encomendas: [],
    pedidosPush: [],
    recebidos: [],
    aceitos: [],
    emProducao: [],
    prontos: [],
    tele: [],
    contadorMensal: 0,
    contadorMensalCor: "",
    controle: [],
    nomePlano: "Carregando plano...",
    infoPlano: "",
    dialogAberto: false,
    dialogCartaoVisivel: false,
    planoSelecionado: null,
    cartaoSelecionado: null,
    planoCompleto: null,
    dialogLimiteAtingido: false,
  }),
  watch: {
    pedidos(n) {
      this.getContador(n);
    },
    count(n) {
      this.getContador(n);
    },
  },
  computed: {
    ...mapGetters(["pedidos", "count", "database", "dadosEmpresa"]),
    mostrarContadorMensal() {
      return this.planoCompleto && this.planoCompleto.value === 'Gratuito';
    },
    empresaEstaAtiva() {
        return this.dadosEmpresa?.horarios?.[0]?.empresaAtiva === true;
    }
  },
  methods: {
    async cancelamento() {
      await desativaPedidos(this.database.cnpj)
    },
    formatPlanoDetails(plano) {
      if (!plano) return 'Nenhum detalhe disponível';
      const details = [];
      if (plano.title) details.push(`Plano: ${plano.title}`);
      if (plano.value) details.push(`Valor: ${plano.value}`);
      if (plano.description) details.push(`Descrição: ${plano.description}`);
      if (plano.features?.length) {
        details.push(`\nRecursos incluídos:`);
        plano.features.forEach(feat => details.push(`• ${feat}`));
      }
      if (plano.acessos) {
        details.push(`\nSeções disponíveis:`);
        for (const [key, value] of Object.entries(plano.acessos)) {
          const sectionName = this.formatSectionName(key);
          const items = value.filter(item => !item.header).map(item => item.value || item.group);
          if (items.length) {
            details.push(`\n${sectionName}:`);
            items.forEach(item => details.push(`- ${item}`));
          }
        }
      }
      return details.join('\n');
    },
    formatSectionName(key) {
      const names = {
        'dadosCadastrais': 'Dados Cadastrais',
        'cadastro': 'Cadastro',
        'pedidosEncomendas': 'Pedidos/Encomendas',
        'controle': 'Controle Financeiro'
      };
      return names[key] || key;
    },
    async carregarPlano() {
      try {
        const plano = await getPlanos(this.database.cnpj);
        this.planoCompleto = plano;
        if (this.planoCompleto) {
          this.nomePlano = this.planoCompleto.title;
          this.planoDetails = this.formatPlanoDetails(this.planoCompleto);
        } else {
          this.nomePlano = "Plano não configurado";
          this.planoDetails = "Nenhum detalhe disponível";
        }
      } catch (error) {
        this.nomePlano = "Erro ao carregar";
        this.planoDetails = "Não foi possível carregar os detalhes";
        console.error("Falha ao carregar plano:", error);
      }
    },
    changeRoute(n) {
      if (this.controle.find((v) => v.route == n)) {
        this.$router.push(n);
      } else {
        console.error('Permissao negada');
      }
    },
    fecharDialogLimite() {
      this.dialogLimiteAtingido = false;
    },
    async getContador(n) {
      (this.encomendas = []),
        (this.pedidosPush = []),
        (this.recebidos = []),
        (this.aceitos = []),
        (this.emProducao = []),
        (this.prontos = []),
        (this.tele = []);
      this.contadorMensal = this.count;
      const limite = 30;
      const limiteExcedido = this.contadorMensal >= limite;
      const empresaAtiva = this.empresaEstaAtiva;
      if (this.planoCompleto && this.planoCompleto.value === 'Gratuito') {
        if (limiteExcedido) {
          this.contadorMensalCor = "red";
          if (limiteExcedido && empresaAtiva) {
            this.dialogLimiteAtingido = true;
          }
        } else {
          this.contadorMensalCor = "green";
          this.dialogLimiteAtingido = false;
        }
      } else {
        this.contadorMensalCor = "green"; 
        this.dialogLimiteAtingido = false;
      } 
      for (var i = 0; i < n.length; i++) {
        if (n[i].dataEntrega && this.$route.path.match("/encomendas")) {
          this.encomendas.push(n[i]);
        } else if (!n[i].dataEntrega && this.$route.path.match("/pedidos")) {
          this.pedidosPush.push(n[i]);
        }
      }
      for (var encomenda of this.encomendas) {
        if (encomenda != "") {
          if (encomenda.status == null) {
            this.recebidos.push(1);
          } else if (encomenda.status == "Aceito") {
            this.aceitos.push(1);
          } else if (encomenda.status == "recebido") {
            this.emProducao.push(1);
          } else if (encomenda.status.match("tele")) {
            this.prontos.push(1);
          }
        }
      }
      for (var pedido of this.pedidosPush) {
        if (pedido != "") {
          if (pedido) {
            if (pedido.status == null) {
              this.recebidos.push(1);
            } else if (pedido.status == "recebido") {
              this.emProducao.push(1);
            } else if (pedido.status == "pronto") {
              this.prontos.push(1);
            } else if (pedido.status.match("tele")) {
              this.tele.push(1);
            }
          }
        }
      }
      var numeroContagem = this.count.toString().trim()
      if (numeroContagem >= 30) {
        const numeroPedidoExcedente = numeroContagem - 30;
        await updatePedidosExcedentes(numeroPedidoExcedente, this.database.cnpj).then(async (a) => {
          console.log(`Numero de Pedidos Excedentes Atualizado!\nPedidos Excedentes Atuais: ${a}`);
          console.warn("Contador dessincronizado. Recarregando...");
          window.location.reload();
        });
      }
    },
    setDialog(abrir) {
      this.dialogAberto = abrir;
    },
    abrirDialogoCartao() {
      this.dialogCartaoVisivel = true;
    },
    async handlePlanoSelecionado(plano) {
      this.planoSelecionado = plano;
      await updatePlanCadastro(this.planoSelecionado, this.database.cnpj);
    },
    handleCartaoSelecionado(cartao) {
      this.cartaoSelecionado = cartao;
    },
  },
  created() {
    this.carregarPlano().then(() => {
        this.getContador(this.pedidos);
    });
    if (this.database.telas.pedidosEncomendas) {
      for (let controle of this.database.telas.pedidosEncomendas) {
        if (controle.group) {
          if (controle.group == 'Encomendas' && controle.value == 'Recebimentos') {
            this.controle.push({ name: "Recebimentos", route: "/encomendas/recebimentos" });
          } else if (controle.group == 'Encomendas' && controle.value == 'Aceitos') {
            this.controle.push({ name: "Aceitos", route: "/encomendas/aceitos" });
          } else if (controle.group == 'Encomendas' && controle.value == 'Em Producao') {
            this.controle.push({ name: "Em Producao", route: "/encomendas/emproducao" });
          } else if (controle.group == 'Encomendas' && controle.value == 'Pronto') {
            this.controle.push({ name: "Pronto", route: "/encomendas/pronto" });
          } else if (controle.group == 'Encomendas' && controle.value == 'Tele | Aguardando Retirada') {
            this.controle.push({ name: "Tele | Aguardando Retirada", route: "/encomendas/tele" });
          } else if (controle.group == 'Pedidos' && controle.value == 'Recebimentos') {
            this.controle.push({ name: "Recebimentos", route: "/pedidos/recebimentos" });
          } else if (controle.group == 'Pedidos' && controle.value == 'Em Producao') {
            this.controle.push({ name: "Em Producao", route: "/pedidos/emproducao" });
          } else if (controle.group == 'Pedidos' && controle.value == 'Pronto') {
            this.controle.push({ name: "Pronto", route: "/pedidos/pronto" });
          } else if (controle.group == 'Pedidos' && controle.value == 'Tele | Aguardando Retirada') {
            this.controle.push({ name: "Tele | Aguardando Retirada", route: "/pedidos/tele" });
          }
        }
      }
    }
  },
};
</script>
<style lang="scss" scoped></style>